export enum LeaveCategories {
    ContinuousProtected = -1,
    IntermittentProtected = -2,
    Unprotected = -3,
    ADA = -4
}